import type { ReactNode } from 'react';

import './Stack.css';

export type Space = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 8 | 10 | 12 | 16;

export interface StackProps {
  /** column stacks top to bottom; row runs along the reading direction. */
  direction?: 'column' | 'row';
  /** A step on the 4px spacing scale: 4 is 1rem. */
  gap?: Space;
  align?: 'start' | 'center' | 'end' | 'stretch' | 'baseline';
  justify?: 'start' | 'center' | 'end' | 'between';
  wrap?: boolean;
  children?: ReactNode;
  /** The element to render, for semantics: a list, a section, a form. */
  as?: 'div' | 'section' | 'ul' | 'ol' | 'form' | 'header' | 'footer';
}

/**
 * Stack spaces its children evenly in one direction. It is the only spacing
 * tool a page needs: rather than margins on children, wrap them in a Stack and
 * pick a gap from the scale.
 */
export function Stack({
  direction = 'column',
  gap = 4,
  align,
  justify,
  wrap = false,
  children,
  as: Element = 'div',
}: StackProps) {
  return (
    <Element
      className="rs-stack"
      data-direction={direction}
      data-align={align}
      data-justify={justify}
      data-wrap={wrap || undefined}
      style={{ gap: `var(--space-${String(gap)})` }}
    >
      {children}
    </Element>
  );
}
